'use client';

import { c as _c } from "react/compiler-runtime";
import { ToggleGroup, ToggleGroupItem } from '@achra/ui/toggle-group';
import { useMemo } from 'react';
import type { RsBillingCycle } from '@/modules/__generated__/graphql/switchboard-generated';
import { getAvailableCycles, PERIOD_LABELS } from '@/modules/service-purchase/lib/billing-period';
import { computePeriodDiscountLabel, resolveDiscountReferenceTierId } from '@/modules/service-purchase/lib/price-breakdown-utils';
import { useComputedTiers, useOptionGroups, useSelectedAddOns, useSelectedTier, useServiceOffering, useServicePurchaseActions, useServicePurchaseState } from '@/modules/service-purchase/providers/service-purchase-store-provider';
function BillingPeriodSelector() {
  const $ = _c(41);
  const servicesData = useServiceOffering();
  const selectedTier = useSelectedTier();
  const allTiers = useComputedTiers();
  const {
    selectedBillingCycle
  } = useServicePurchaseState();
  const {
    setSelectedBillingCycle
  } = useServicePurchaseActions();
  const optionGroups = useOptionGroups();
  const selectedAddOns = useSelectedAddOns();
  let T0;
  let t0;
  let t1;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  if ($[0] !== allTiers || $[1] !== optionGroups || $[2] !== selectedAddOns || $[3] !== selectedBillingCycle || $[4] !== selectedTier || $[5] !== servicesData || $[6] !== setSelectedBillingCycle) {
    t8 = Symbol.for("react.early_return_sentinel");
    bb0: {
      const availableCycles = getAvailableCycles(servicesData.availableBillingCycles);
      let t9;
      if ($[17] !== optionGroups || $[18] !== selectedAddOns) {
        t9 = new Set([...optionGroups.map(_temp), ...selectedAddOns.map(_temp2)]);
        $[17] = optionGroups;
        $[18] = selectedAddOns;
        $[19] = t9;
      } else {
        t9 = $[19];
      }
      const activeGroupIds = t9;
      let t10;
      if ($[20] !== activeGroupIds || $[21] !== allTiers || $[22] !== selectedBillingCycle || $[23] !== selectedTier || $[24] !== servicesData) {
        t10 = resolveDiscountReferenceTierId(servicesData, selectedTier, allTiers, selectedBillingCycle, activeGroupIds);
        $[20] = activeGroupIds;
        $[21] = allTiers;
        $[22] = selectedBillingCycle;
        $[23] = selectedTier;
        $[24] = servicesData;
        $[25] = t10;
      } else {
        t10 = $[25];
      }
      const discountReferenceTierId = t10;
      if (availableCycles.length === 0) {
        t8 = null;
        break bb0;
      }
      t6 = "flex flex-col items-center gap-3 sm:flex-row sm:justify-center";
      if ($[26] === Symbol.for("react.memo_cache_sentinel")) {
        t7 = <label className="text-foreground/60 text-base font-medium">Billing Cycles:</label>;
        $[26] = t7;
      } else {
        t7 = $[26];
      }
      T0 = ToggleGroup;
      t0 = "single";
      t1 = selectedBillingCycle;
      if ($[27] !== setSelectedBillingCycle) {
        t2 = value => {
          if (value) {
            setSelectedBillingCycle(value as RsBillingCycle);
          }
        };
        $[27] = setSelectedBillingCycle;
        $[28] = t2;
      } else {
        t2 = $[28];
      }
      t3 = "Billing period";
      t4 = "gap-1";
      t5 = availableCycles.map(cycle => {
        const discountLabel = selectedTier.isCustomPricing ? cycle !== availableCycles[0] ? "Custom" : null : computePeriodDiscountLabel(servicesData, discountReferenceTierId, cycle, activeGroupIds);
        return <ToggleGroupItem key={cycle} value={cycle} className="group border-border data-[state=off]:bg-background data-[state=off]:text-foreground data-[state=off]:hover:bg-accent data-[state=on]:bg-primary data-[state=on]:text-primary-foreground data-[state=on]:border-primary data-[state=on]:hover:bg-primary/90 flex h-9.5 flex-none cursor-pointer items-center gap-2 rounded-md border px-3 py-2 text-sm/5.5 font-normal">{PERIOD_LABELS[cycle]}{discountLabel && <span className="bg-primary text-primary-foreground group-data-[state=on]:bg-primary-foreground group-data-[state=on]:text-primary rounded-full border border-transparent px-2.5 py-0.5 text-xs font-medium">{discountLabel}</span>}</ToggleGroupItem>;
      });
    }
    $[0] = allTiers;
    $[1] = optionGroups;
    $[2] = selectedAddOns;
    $[3] = selectedBillingCycle;
    $[4] = selectedTier;
    $[5] = servicesData;
    $[6] = setSelectedBillingCycle;
    $[7] = T0;
    $[8] = t0;
    $[9] = t1;
    $[10] = t2;
    $[11] = t3;
    $[12] = t4;
    $[13] = t5;
    $[14] = t6;
    $[15] = t7;
    $[16] = t8;
  } else {
    T0 = $[7];
    t0 = $[8];
    t1 = $[9];
    t2 = $[10];
    t3 = $[11];
    t4 = $[12];
    t5 = $[13];
    t6 = $[14];
    t7 = $[15];
    t8 = $[16];
  }
  if (t8 !== Symbol.for("react.early_return_sentinel")) {
    return t8;
  }
  let t9;
  if ($[29] !== T0 || $[30] !== t0 || $[31] !== t1 || $[32] !== t2 || $[33] !== t3 || $[34] !== t4 || $[35] !== t5) {
    t9 = <T0 type={t0} value={t1} onValueChange={t2} aria-label={t3} className={t4}>{t5}</T0>;
    $[29] = T0;
    $[30] = t0;
    $[31] = t1;
    $[32] = t2;
    $[33] = t3;
    $[34] = t4;
    $[35] = t5;
    $[36] = t9;
  } else {
    t9 = $[36];
  }
  let t10;
  if ($[37] !== t6 || $[38] !== t7 || $[39] !== t9) {
    t10 = <div className={t6}>{t7}{t9}</div>;
    $[37] = t6;
    $[38] = t7;
    $[39] = t9;
    $[40] = t10;
  } else {
    t10 = $[40];
  }
  return t10;
}
function _temp2(a) {
  return a.id;
}
function _temp(g) {
  return g.id;
}
export { BillingPeriodSelector };